interface SectionHeaderProps {
  title: string;
  className?: string;
}

/**
 * Reusable section header for DiscoverScreenV2 sections.
 * Renders the title in American Captain font with a faint white dividing line beneath.
 * Used for "Similar Interests", "New Yappers This Week", "Trending Yaps", etc.
 */
export function SectionHeader({ title, className = '' }: SectionHeaderProps) {
  return (
    <div className={`w-full pt-4 ${className}`}>
      {/* div instead of h2 — globals.css overrides h1/h2 with NarnialOne !important */}
      <div
        className="font-american-captain text-white uppercase leading-none mb-3"
        style={{ fontSize: '1.5rem', letterSpacing: '0.04em', fontFamily: "'AmericanCaptain', 'Poppins', sans-serif" }}
      >
        {title}
      </div>
      <div className="w-full h-px" style={{ background: 'rgba(255,255,255,0.18)' }} />
    </div>
  );
}
